//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import PartialCuid from '@models/PartialCuid';
import {
  IShareMediaItem,
  PublisherModerationStatus,
} from '@share/models/shareStateModel';

import { ISelectedItem } from 'app/bulk-actions/model/ISelectedItem';

const getShareItems = (state: ICuralateStore) => state.share.data.items;
const getBulkActionsSelectedItems = (state: ICuralateStore) =>
  state.bulkActions.selectedItems;

export const getSharedItemsEligibleToRequestReviewNow = createSelector(
  getShareItems,
  getBulkActionsSelectedItems,
  (
    shareItems: IShareMediaItem[],
    bulkActionsSelectedItems: ISelectedItem[],
  ) => {
    return shareItems.filter((sharedItem) => {
      const sharedCuid = PartialCuid(
        `${sharedItem.networkItem.network}.${sharedItem.networkItem.id}`,
      );
      const isCuidSelected = bulkActionsSelectedItems
        .map((si) => si.cuid)
        .includes(sharedCuid);
      const publisherModerationStatus =
        sharedItem.shareMetadata.publisherModerationStatus;
      return (
        isCuidSelected &&
        publisherModerationStatus === PublisherModerationStatus.NEEDS_PRODUCTS
      );
    });
  },
);

export default getSharedItemsEligibleToRequestReviewNow;
